import React, {useEffect, useState} from "react";
import {Container, Grid, Paper, Textarea, TextInput, Title, Button, LoadingOverlay} from "@mantine/core";
import {useForm} from "@mantine/form";
import api from "../../../services/api";
import NotificationFactory from "../../../Helpers/notificationFactory";
import {DateInput} from "@mantine/dates";


export default function EditEvent({match, history}) {
    const token = sessionStorage.getItem('user_token');
    const [loading, setLoading] = useState(true);
    const eventId = match.params.id;
    const form = useForm({
        initialValues: {
            title: '',
            description: '',
            start_date: new Date(),
            end_date: new Date()
        },
    });

    function loadInitialValues() {
        return new Promise(async (resolve) => {
            const response = await api.get(`admin/events/${eventId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });
            setTimeout(() => resolve({
                title: response.data.title,
                description: response.data.description,
                start_date: new Date(response.data.start_date),
                end_date: new Date(response.data.end_date)
            }), 300);
        });
    }

    useEffect(() => {
        loadInitialValues().then((values) => {
            form.setValues(values);
            form.resetDirty(values);
            setLoading(false);
        });
    }, []);

    async function handleSubmit() {
        const formData = form.values;
        try {
            await api.patch(`/admin/events/${eventId}`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });
            NotificationFactory('success', 'Evento Modificado', 'Seu evento foi modificado com sucesso');
            history.push('/eventos');
        } catch (e) {
            console.log(e.response.data);
            NotificationFactory('error', 'Erro ao modificar evento', 'Não foi possível concluir a ação');
        }
    }

    if (loading) {
        return <LoadingOverlay visible={loading}/>
    } else {
        return (
            <Container fluid>
                <Paper shadow="md" radius="md" p="md">
                    <Title order={2} mb="md">Editar Detalhes do Evento</Title>
                    <form onSubmit={form.onSubmit(handleSubmit)}>
                        <Grid>
                            <Grid.Col xs={12}>
                                <TextInput
                                    placeholder="Título do Evento"
                                    label="Título do Evento"
                                    withAsterisk
                                    {...form.getInputProps('title')}
                                />
                            </Grid.Col>

                            <Grid.Col xs={12}>
                                <Textarea
                                    placeholder="Descrição"
                                    label="Descrição"
                                    withAsterisk
                                    autosize
                                    minRows={2}
                                    {...form.getInputProps('description')}
                                />
                            </Grid.Col>

                            <Grid.Col xs={12} md={6}>
                                <DateInput
                                    valueFormat="DD/MM/YYYY"
                                    label="Data de Início"
                                    withAsterisk
                                    placeholder="Data de Início"
                                    {...form.getInputProps('start_date')}
                                />
                            </Grid.Col>

                            <Grid.Col xs={12} md={6}>
                                <DateInput
                                    valueFormat="DD/MM/YYYY"
                                    label="Data de Fim"
                                    withAsterisk
                                    placeholder="Data de Fim"
                                    {...form.getInputProps('end_date')}
                                />
                            </Grid.Col>

                            <Grid.Col xs={12}>
                                <Button type="submit">Editar Evento</Button>
                            </Grid.Col>
                        </Grid>
                    </form>
                </Paper>
            </Container>
        )
    }
}